import Vue from 'vue'
import MagAddValues from './MagAddValues.vue';

Vue.component('MagAddValues', MagAddValues);
